import { Component, OnInit, inject } from '@angular/core'
import { MessageTapeService } from 'src/app/data/services/components/message-tape/message-tape.service'
import { TypeEnvironment } from 'src/app/domain/enums/application/environment.enum'
import { Icon, IconColor } from 'src/app/domain/enums/components/icon.enum'
import { TypeMessageTape } from 'src/app/domain/enums/components/message-tape.enum'
import { MessageTapeConfig } from 'src/app/domain/interfaces/components/message-tape.interface'

@Component({ selector: 'app-message-tape', templateUrl: './message-tape.component.html', styleUrls: ['./message-tape.component.scss'] })
export class MessageTapeComponent implements OnInit {
  private messageTapeService: MessageTapeService = inject(MessageTapeService)

  isShow: boolean = false
  message: string = ''
  type: TypeMessageTape = TypeMessageTape.DEFAULT

  icon = Icon
  iconColor = IconColor
  typeMessageType = TypeMessageTape

  public ngOnInit(): void {
    this.messageTapeService.getMessageTapeConfig()
    setInterval(() => this.messageTapeService.getMessageTapeConfig(), 3600000)

    this.messageTapeService.messageTapeSubject.subscribe((messageTape: MessageTapeConfig) => this.setActiveMessageTape(messageTape))
  }

  public setActiveMessageTape(messageTapeConfig: MessageTapeConfig): void {
    this.isShow = window.location.hostname === 'localhost' || messageTapeConfig.environment === TypeEnvironment.DEVELOPER || messageTapeConfig.environment === TypeEnvironment.HOMOLOGATION || messageTapeConfig.socketInterrupted || (messageTapeConfig.environment === TypeEnvironment.PRODUCTION && messageTapeConfig.active)
    this.message = messageTapeConfig.message
    this.type = this.setTypeTape(messageTapeConfig)
  }

  private setTypeTape(messageTapeConfig: MessageTapeConfig): TypeMessageTape {
    if (messageTapeConfig.socketInterrupted) return TypeMessageTape.SOCKET_INTERRUPTED

    if (window.location.hostname === 'localhost') return TypeMessageTape.LOCALHOST_ENVIRONMENT
    if (messageTapeConfig.environment === TypeEnvironment.DEVELOPER) return TypeMessageTape.DEVELOPMENT_ENVIRONMENT
    if (messageTapeConfig.environment === TypeEnvironment.HOMOLOGATION) return TypeMessageTape.HOMOLOGATION_ENVIRONMENT
    if (messageTapeConfig.environment === TypeEnvironment.PRODUCTION && messageTapeConfig.active) return TypeMessageTape.SYSTEM_ALERT

    return TypeMessageTape.SYSTEM_ALERT
  }
}
